<ul class="tabs request-tabs mt-1 mb-3">
  <li class="active" (click)="navigateTab('tab1')" [ngClass]="{ active: activeTab === 'tab1' }">My Requests</li>
  <li (click)="navigateTab('tab2')" [ngClass]="{ active: activeTab === 'tab2' }">Correspondence Address Change</li>
  <li (click)="navigateTab('tab3')" [ngClass]="{ active: activeTab === 'tab3' }">Upload Scanned Signature</li>
  <li (click)="navigateTab('tab4')" [ngClass]="{ active: activeTab === 'tab4' }">Bank Account Change</li>
</ul>

<div [ngSwitch]="activeTab" class="mt-4">
  <div *ngSwitchCase="'tab1'" class="request-history">
    <p *ngIf="requestList?.length < 1">No requests found.</p>
    <!-- <h2>Request History</h2> -->
    <ul>
      <li *ngFor="let item of requestList" [ngClass]="item.requestStatus">
        <span>{{ reportType[item.requestType] }} </span> <span> {{ item.date | date : 'yyyy-MM-dd' }}</span>
        <span>{{ item.requestStatus }}</span>
        <div class="col-12 admin-cmnt" [hidden]="item && !item.userComment">
          <b>Admin Comment</b> :: {{ (item && item.userComment) || '' }}
        </div>
      </li>
    </ul>
  </div>

  <div *ngSwitchCase="'tab2'">
    <div style="position: relative">
      <form [formGroup]="addressChangeForm" #addressForm="ngForm" (ngSubmit)="changeAddress(addressForm)" novalidate>
        <div class="row ml-1">
          <div class="col-12 col-md-6">
            <label>Current Address</label>
            <textarea formControlName="currentAddress" rows="3"></textarea>
            <errors
              [on]="
                (addressForm.submitted || addressChangeForm.get('currentAddress').touched) &&
                addressChangeForm.get('currentAddress').invalid
              "
            >
              Required
            </errors>
          </div>
          <div class="col-12 col-md-6">
            <label>New Address</label>
            <textarea formControlName="newAddress" rows="3"></textarea>
            <errors
              [on]="(addressForm.submitted || addressChangeForm.get('newAddress').touched) && addressChangeForm.get('newAddress').invalid"
            >
              Required
            </errors>
          </div>
        </div>
        <div class="row ml-1">
          <div class="col-12 col-md-6">
            <label>Attachment</label>
            <upload
              formControlName="attachment"
              [disableRemove]="false"
              [max]="1024 * 11000"
              allowedTypes="jpg,jpeg,png,pdf"
              (uploadError)="setUploadError($event)"
              [circledImg]="false"
              [uploadLoaction]="'equity-requests'"
            ></upload>
            <p class="text-muted text-center">Max Size 10Mb. <br />JPG, JPEG, PNG and PDF</p>
            <errors [on]="uploadError">
              <span [hidden]="uploadError !== 'invalid-size'">File size must be less than 10MB</span>
              <span [hidden]="uploadError !== 'invalid-file-type'">Only .JPG, .JPEG and .PNG files allowed</span>
            </errors>
            <errors
              [on]="(addressForm.submitted || addressChangeForm.get('attachment').touched) && addressChangeForm.get('attachment').invalid"
            >
              Required
            </errors>
          </div>
        </div>
        <div class="inner-fields p-0 col-12">
          <div class="form-errors alert alert-danger" [hidden]="!submissionErrors">
            {{ submissionErrors }}
          </div>
        </div>

        <div class="form-group row col-12" [hidden]="!successMsg">
          <div class="alert alert-success" role="alert">Thank you for submitting your request</div>
        </div>
        <div class="col-12" style="text-align: right">
          <button type="submit" class="ws-loading {{ submitInProgress ? 'ws-loading-progress' : '' }}">Submit</button>
        </div>
      </form>
    </div>
  </div>
  <div *ngSwitchCase="'tab3'">
    <form [formGroup]="signatureUpload" #signatureForm="ngForm" (ngSubmit)="uploadSignature(signatureForm)" novalidate>
      <div class="row">
        <div class="col-12 col-md-6">
          <label>Attachment</label>
          <upload
            formControlName="attachment"
            [disableRemove]="false"
            [max]="1024 * 11000"
            allowedTypes="jpg,jpeg,png,pdf"
            (uploadError)="setUploadError($event)"
            [circledImg]="false"
            [uploadLoaction]="'equity-requests'"
          ></upload>
          <p class="text-muted text-center">Max Size 10Mb. <br />JPG, JPEG, PNG and PDF</p>
          <errors [on]="uploadError">
            <span [hidden]="uploadError !== 'invalid-size'">File size must be less than 10MB</span>
            <span [hidden]="uploadError !== 'invalid-file-type'">Only .JPG, .JPEG and .PNG files allowed</span>
          </errors>
          <errors
            [on]="(signatureForm.submitted || signatureUpload.get('attachment').touched) && signatureUpload.get('attachment').invalid"
          >
            Required
          </errors>
        </div>
      </div>
      <div class="inner-fields p-0 col-12">
        <div class="form-errors alert alert-danger" [hidden]="!submissionErrors">
          {{ submissionErrors }}
        </div>
      </div>
      <div class="form-group row col-12" [hidden]="!successMsg">
        <div class="alert alert-success" role="alert">Thank you for submitting your request</div>
      </div>
      <div class="col-12" style="text-align: right">
        <button class="ws-loading {{ submitInProgress ? 'ws-loading-progress' : '' }}" type="submit">Submit</button>
      </div>
    </form>
  </div>
  <div *ngSwitchCase="'tab4'">
    <form [formGroup]="bankDetailChange" #bankForm="ngForm" (ngSubmit)="submitBankDetails(bankForm)">
      <div class="border-container">
        <section>
          <h4>Current Bank Details</h4>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="form-group row">
                <label class="col-sm-12">Bank Name</label>
                <div class="col-sm-12">
                  <input formControlName="currentBankName" type="text" />
                  <errors
                    [on]="
                      (bankForm.submitted || bankDetailChange.get('currentBankName').touched) &&
                      bankDetailChange.get('currentBankName').invalid
                    "
                  >
                    Required
                  </errors>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="form-group row">
                <label class="col-sm-12">Account No</label>
                <div class="col-sm-12">
                  <input formControlName="currentAccountNo" oninput="this.value = this.value.replace(/[^0-9]/g, '');" type="text" />
                  <errors
                    [on]="
                      (bankForm.submitted || bankDetailChange.get('currentAccountNo').touched) &&
                      bankDetailChange.get('currentAccountNo').invalid
                    "
                  >
                    Required
                  </errors>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="form-group row">
                <label class="col-sm-12">Branch Name</label>
                <div class="col-sm-12">
                  <input formControlName="currentBranchName" type="text" />
                  <errors
                    [on]="
                      (bankForm.submitted || bankDetailChange.get('currentBranchName').touched) &&
                      bankDetailChange.get('currentBranchName').invalid
                    "
                  >
                    Required
                  </errors>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="form-group row">
                <label class="col-sm-12">Routing No</label>
                <div class="col-sm-12">
                  <input formControlName="currentRoutingNo" oninput="this.value = this.value.replace(/[^0-9]/g, '');" type="text" />
                  <errors
                    [on]="
                      (bankForm.submitted || bankDetailChange.get('currentRoutingNo').touched) &&
                      bankDetailChange.get('currentRoutingNo').invalid
                    "
                  >
                    Required
                  </errors>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <h4>New Bank Details</h4>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="form-group row">
                <label class="col-sm-12">Bank Name</label>
                <div class="col-sm-12">
                  <input formControlName="newBankName" type="text" />
                  <errors
                    [on]="
                      (bankForm.submitted || bankDetailChange.get('newBankName').touched) && bankDetailChange.get('newBankName').invalid
                    "
                  >
                    Required
                  </errors>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="form-group row">
                <label class="col-sm-12">Account No</label>
                <div class="col-sm-12">
                  <input formControlName="newAccountNo" oninput="this.value = this.value.replace(/[^0-9]/g, '');" type="text" />
                  <errors
                    [on]="
                      (bankForm.submitted || bankDetailChange.get('newAccountNo').touched) && bankDetailChange.get('newAccountNo').invalid
                    "
                  >
                    Required
                  </errors>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="form-group row">
                <label class="col-sm-12">Branch Name</label>
                <div class="col-sm-12">
                  <input formControlName="newBranchName" type="text" />
                  <errors
                    [on]="
                      (bankForm.submitted || bankDetailChange.get('newBranchName').touched) && bankDetailChange.get('newBranchName').invalid
                    "
                  >
                    Required
                  </errors>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="form-group row">
                <label class="col-sm-12">Routing No</label>
                <div class="col-sm-12">
                  <input formControlName="newRoutingNo" oninput="this.value = this.value.replace(/[^0-9]/g, '');" type="text" />
                  <errors
                    [on]="
                      (bankForm.submitted || bankDetailChange.get('newRoutingNo').touched) && bankDetailChange.get('newRoutingNo').invalid
                    "
                  >
                    Required
                  </errors>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="inner-fields p-0 col-12">
        <div class="form-errors alert alert-danger" [hidden]="!submissionErrors">
          {{ submissionErrors }}
        </div>
      </div>
      <div class="form-group row col-12" [hidden]="!successMsg">
        <div class="alert alert-success" role="alert">Thank you for submitting your request</div>
      </div>
      <div class="col-12" style="text-align: right">
        <button class="ws-loading {{ submitInProgress ? 'ws-loading-progress' : '' }}" [disabled]="successMsg" type="submit">Submit</button>
      </div>
    </form>
  </div>
</div>
